const MIN_DECIMALS = 2;
const MAX_DECIMALS = 3;

/** A kmod/γM as the standards write it: two decimals (1.30), more only when the value needs them (1.375). */
export const formatCoefficient = (value: number): string => {
  const rounded = Number(value.toFixed(MAX_DECIMALS));
  const needed = (String(rounded).split(".")[1] ?? "").length;
  return rounded.toFixed(Math.max(MIN_DECIMALS, needed));
};

export const formatCoefficientOrDash = (value: number | null | undefined): string =>
  value == null ? "—" : formatCoefficient(value);
